import { render, staticRenderFns } from "./vulnTable.vue?vue&type=template&id=7133f3b0&scoped=true&"
import script from "./vulnTable.vue?vue&type=script&lang=ts&"
export * from "./vulnTable.vue?vue&type=script&lang=ts&"
import style0 from "./vulnTable.vue?vue&type=style&index=0&id=7133f3b0&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7133f3b0",
  null
  
)

export default component.exports